"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME_COLLATOR = void 0;
exports.compareNames = compareNames;
exports.sortByName = sortByName;
/**
 * ATOC-1 A11 — Erik: "Also make all the tables list all the data alphabetically based on the
 * name/codes."
 *
 * One comparator for every table and dropdown, because the app had grown three different ones:
 * a bare `localeCompare(b)`, `localeCompare(b, undefined, { numeric: true })`, and
 * `localeCompare(b, "en", { numeric: true, sensitivity: "base" })`. They disagree, which is why
 * SHOP-2 sorted after SHOP-10 on some screens and before it on others.
 *
 * The options are the ones the area numbers actually need:
 *   - `numeric` so SHOP-2 comes before SHOP-10 rather than after it (plain string order compares
 *     "1" < "2" character by character, which puts 10 first).
 *   - `sensitivity: "base"` so case and accents do not split otherwise-identical names apart.
 *
 * This deliberately matches the collation the API sorts with — `{ locale: "en", strength: 2,
 * numericOrdering: true }` — so a list ordered server-side and the same list ordered here agree.
 *
 * A single `Intl.Collator` is reused rather than calling `String.localeCompare` per comparison: the
 * collator is built once instead of on every one of the n·log n comparisons.
 */
var NAME_COLLATOR = new Intl.Collator("en", { numeric: true, sensitivity: "base" });
exports.NAME_COLLATOR = NAME_COLLATOR;
/** Compares two names/codes. Nullish sorts as empty, so blank rows group at the top rather than throwing. */
function compareNames(a, b) {
    return NAME_COLLATOR.compare(a !== null && a !== void 0 ? a : "", b !== null && b !== void 0 ? b : "");
}
/**
 * Returns a NEW array sorted by the given key. Never sorts in place — the arrays this is handed are
 * usually RTK Query results, which are frozen in development and shared across components.
 */
function sortByName(items, key) {
    return __spreadArray([], items, true).sort(function (a, b) { return compareNames(key(a), key(b)); });
}
